import {ModelProperties} from '../utils';

export class CtPageCategory {
    id!: number;

    name!: string;

    constructor(page?: ModelProperties<CtPageCategory>) {
        if (page) {
            Object.assign(this, page);
        }
    }
}